export default [
  {
    path: '/referidos-global',
    name: 'referralsGlobal',
    component: () => import('@/views/referrals/ReferralsDashboard.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/referidos/:customerId?',
    name: 'referrals',
    component: () => import('@/views/referrals/ReferralsDashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
